module.exports = __webpack_public_path__ + "img/Title_kuraray1.2fea976e.png";